var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-row',{staticClass:"create_team"},[_c('b-col',{staticClass:"text-left",attrs:{"cols":"8"}},[_c('h4',[_vm._v("AutoProcessing ")])]),_vm._v(" "),_c('b-col',{staticClass:"float-right",attrs:{"md":"4"}},[_c('c-switch',{attrs:{"type":"3d","variant":"success","checked":_vm.is_auto_processing},on:{"change":function($event){_vm.autoProcessing($event)}}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-402711d4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/autoProcessing.vue
// module id = 1275
// module chunks = 1